import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class StatusCardService {

  constructor(
    private httpService: HttpService, private http: HttpService,
  ) { } 

  buscaLimiteGlobal(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);

  }

  balanceDetailViewList(data: any, successHandle:Function, errorHandle:Function) {

    this.http.doGet('/enterprise/retailAccountBalance', data, successHandle, errorHandle);

 }

 

}
